import { IController } from 'angular';

export class AssignSupportsCtrl implements IController {
  static $inject = [];

  constructor() {
    //
  }
}
